// @noflow

/**
 * @param {node} el - передаем селектор, у которого ищем соседей
 * @returns получаем массив элементов, которые находятся рядом с селектором
 */
export const getSiblings = (el) => [].slice.call(el.parentNode.children).filter((child) => child !== el)
